import * as React from 'react'
import { IAutochargeConfigResponseDTO, IPaymentSourceResponseDTO, IRiderObject } from '../../../../types'
import Modal from '../../../ui/Modal'
import UIMessages from '../../../../utils/ui-messages'
import { Input, Switch, Select, Button } from '@mobiscroll/react-latest'

export interface IAutochargeModalProps {
  rider: IRiderObject
  onClose: () => void
  updateAutochargeWallet: (rider: IRiderObject, autocharge: IAutochargeConfigResponseDTO) => Promise<any>
}

interface IAutochargeModalState {
  isSubmitting: boolean
  autocharge: IAutochargeConfigResponseDTO
}

class AutochargeModal extends React.Component<IAutochargeModalProps, IAutochargeModalState> {
  constructor(props: IAutochargeModalProps) {
    super(props)
    this.state = {
      isSubmitting: false,
      autocharge:
        this.props.rider && this.props.rider.walletAutocharge
          ? Object.assign({}, this.props.rider.walletAutocharge)
          : {
              lowerLimit: undefined,
              rechargeTo: undefined,
              isEnabled: false,
              paymentSource: ''
            }
    }
  }

  public render() {
    const ToggleButton = require('react-toggle-button')
    const contentStyle: any = {
      pointerEvents: !this.state.autocharge.isEnabled ? 'none' : 'auto',
      opacity: !this.state.autocharge.isEnabled ? 0.4 : 1.0
    }

    //TODO: extract payment dropdown into common component
    const pmethods: Array<{ text: string; value: string }> = []
    if (this.props.rider && this.props.rider.wallet) {
      for (const idx of Object.keys(this.props.rider.wallet.sources)) {
        const pmethod: IPaymentSourceResponseDTO = this.props.rider.wallet.sources[idx]
        pmethods.push({
          text: `${pmethod.last4}- EXP ${pmethod.exp_month}/${pmethod.exp_year}`,
          value: pmethod.id
        })
      }
    }

    const saveText = this.state.isSubmitting ? 'Saving...' : 'Save'

    const getPaymentMethods = () => {
      if (pmethods.length === 0) {
        return [
          {
            text: 'No Options',
            value: 'No Options',
            disabled: true
          }
        ]
      } else {
        return pmethods
      }
    }

    const getPaymentMethodValue = () => {
      const selectedPMethod = pmethods.find(pm => pm.value === this.state.autocharge.paymentSource)
      if (selectedPMethod !== undefined) {
        return selectedPMethod.text
      } else {
        return ''
      }
    }

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='med-modal'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>
              {UIMessages.common.autoChargeConfiguration}
            </span>
            <div
              style={{
                pointerEvents: this.state.isSubmitting ? 'none' : 'auto',
                opacity: this.state.isSubmitting ? 0.4 : 1.0
              }}
              className='border-top mt1'
            >
              <div className='flex mb2 mt1 pt2 items-center'>
                <div className='h5 font-grey2'>{UIMessages.common.enableAutoCharging}</div>
                <div style={{ flex: 1 }}>&nbsp;</div>
                <Switch checked={this.state.autocharge.isEnabled} onChange={this.onToggle} position='end' />
              </div>

              <div style={contentStyle} className='mt1'>
                <div className='mb1'>
                  <div>
                    <Input
                      type='number'
                      className='mobiscroll-input form'
                      onChange={this.onChangeBelow}
                      placeholder='0.00'
                      value={
                        this.state.autocharge.lowerLimit !== undefined ? `${this.state.autocharge.lowerLimit}` : ''
                      }
                      theme='ios'
                      themeVariant='light'
                      inputStyle='box'
                      label={UIMessages.common.ifBalanceFallsBelow}
                      labelStyle='floating'
                    />
                  </div>
                </div>
                <div className='mb1'>
                  <div>
                    <Input
                      type='number'
                      className='mobiscroll-input form'
                      onChange={this.onRechargeTo}
                      placeholder='0.00'
                      value={
                        this.state.autocharge.rechargeTo !== undefined ? `${this.state.autocharge.rechargeTo}` : ''
                      }
                      theme='ios'
                      themeVariant='light'
                      inputStyle='box'
                      label={UIMessages.common.rechargeBalanceTo}
                      labelStyle='floating'
                    />
                  </div>
                </div>

                <div className='mb1'>
                  <Select
                    name='SelectPaymentMethod'
                    value={getPaymentMethodValue()}
                    onChange={this.onPaymentMethodChange}
                    data={getPaymentMethods()}
                    touchUi={false}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={UIMessages.common.paymentMethod}
                    labelStyle='floating'
                  />
                </div>
              </div>
            </div>
            <div className='flex items-center justify-end mt3'>
              <Button
                type='button'
                ariaLabel='cancel'
                onClick={this.handleCancelClick}
                disabled={this.state.isSubmitting}
                className='mbsc-clear-btn mr2'
              >
                Cancel
              </Button>
              <Button
                type='button'
                ariaLabel='submit'
                onClick={this.onSave}
                disabled={this.state.isSubmitting}
                className='mbsc-green-btn'
              >
                {saveText}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private onPaymentMethodChange = (event: any) => {
    if (event.value !== null) {
      this.setState({
        autocharge: {
          ...this.state.autocharge,
          paymentSource: event.value
        }
      })
    }
  }

  private onChangeBelow = (event: any) => {
    const val = event.target.value
    this.setState({
      autocharge: {
        ...this.state.autocharge,
        lowerLimit: val
      }
    })
  }

  private onRechargeTo = (event: any) => {
    const val = event.target.value
    this.setState({
      autocharge: {
        ...this.state.autocharge,
        rechargeTo: val
      }
    })
  }

  private onToggle = (value: boolean) => {
    this.setState({
      autocharge: {
        ...this.state.autocharge,
        isEnabled: !this.state.autocharge.isEnabled
      }
    })
  }

  private onSave = (event: any) => {
    this.setState({ isSubmitting: true }, () => {
      this.props
        .updateAutochargeWallet(this.props.rider, {
          ...this.state.autocharge
        })
        .then(() => {
          this.handleCancelClick()
        })
    })
  }

  private handleCancelClick = () => {
    this.props.onClose()
  }
}

export default AutochargeModal



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/AutochargeModal.tsx